var _rect, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAttachmentContent = function SvgAttachmentContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#41D9F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.947 24.474a744.088 744.088 0 0 0-3.087 3.124c-1.756 1.798-4.581 1.702-6.43-.14-1.85-1.839-1.95-4.667-.15-6.427 3.153-3.1 6.404-6.339 9.518-9.508 2.063-2.112 5.354-2.012 7.508.136 2.125 2.108 1.618 4.781-.95 6.429 1.5-1.477 1.441-3.86-.09-5.385-1.53-1.525-3.913-1.582-5.387-.084a951.82 951.82 0 0 1-6.381 6.402c-.257-.256.257.256 0 0-1.045 1.04-2.087 2.074-3.117 3.093-1.192 1.174-1.138 3.084.087 4.304 1.225 1.22 3.134 1.271 4.306.08 1.814-1.837 3.677-3.708 5.542-5.571.903-.9.902-2.368 0-3.27-.888-.887-2.347-.926-3.229-.043 1.418-2.176 2.945-2.41 4.314-1.042a3.828 3.828 0 0 1 .002 5.44c-.255-.253.255.256 0 0-.822.821-1.643 1.644-2.459 2.466-.253-.256.258.253.003-.004Z",
    fill: "url(#attachment-content_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.957 16.568c-.819.82-1.64 1.64-2.46 2.454a.382.382 0 0 0 0 .543l.547.544c.15.15.395.15.545 0a2344.67 2344.67 0 0 0 2.498-2.494c1.5-1.475 3.417-1.94 4.314-1.042a3.836 3.836 0 0 0-5.444-.005Z",
    fill: "url(#attachment-content_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.45 19.166a710.7 710.7 0 0 0-6.426 6.395.38.38 0 0 1-.54.003l-.539-.544a.388.388 0 0 1 .002-.545c2.126-2.14 4.286-4.29 6.408-6.387 2.104-2.069 2.493-4.897.951-6.428 2.16 2.145 2.262 5.439.144 7.506Z",
    fill: "url(#attachment-content_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "attachment-content_svg__a",
    x1: 0.851,
    y1: 36.264,
    x2: 58.739,
    y2: -17.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "attachment-content_svg__b",
    x1: 15.128,
    y1: 20.231,
    x2: 26.169,
    y2: 9.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "attachment-content_svg__c",
    x1: 37.008,
    y1: 8.864,
    x2: 20.197,
    y2: 26.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#fff"
  })))));
};

export default SvgAttachmentContent;